// Mock data for ScrollEd - Social learning network from PDFs

export const mockInstances = [
  {
    id: '1',
    name: 'Romeo & Juliet',
    status: 'ready',
    created_at: '2025-01-01T10:00:00Z',
    document_title: 'Romeo and Juliet - William Shakespeare'
  },
  {
    id: '2', 
    name: 'Alice in Wonderland',
    status: 'processing',
    progress: 75,
    created_at: '2025-01-02T14:30:00Z',
    document_title: 'Alice\'s Adventures in Wonderland - Lewis Carroll'
  },
  {
    id: '3',
    name: 'The Great Gatsby',
    status: 'ready',
    created_at: '2024-12-28T09:15:00Z',
    document_title: 'The Great Gatsby - F. Scott Fitzgerald'
  }
];

export const mockEntities = {
  '1': [
    {
      id: 'romeo_montague',
      type: 'character',
      name: 'Romeo Montague',
      handle: '@romeo_montague',
      bio: 'Young lover from the House of Montague. Passionate, impulsive, and hopelessly romantic. Currently pining after fair Juliet. 💕',
      avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
      followers: 2847,
      following: 156,
      posts_count: 23,
      verified: true
    },
    {
      id: 'juliet_capulet',
      type: 'character', 
      name: 'Juliet Capulet',
      handle: '@juliet_capulet',
      bio: 'Daughter of House Capulet. Only 13 but wise beyond my years. Love knows no boundaries. 🌹',
      avatar_url: 'https://images.unsplash.com/photo-1494790108755-2616c307b90f?w=150&h=150&fit=crop&crop=face',
      followers: 3241,
      following: 89,
      posts_count: 19,
      verified: true
    },
    {
      id: 'mercutio',
      type: 'character',
      name: 'Mercutio',
      handle: '@mercutio_wit',
      bio: 'Romeo\'s best friend and the life of every party. Known for my Queen Mab speeches and sword skills. ⚔️',
      avatar_url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
      followers: 1892,
      following: 234,
      posts_count: 31,
      verified: false
    },
    {
      id: 'verona_city',
      type: 'location',
      name: 'Fair Verona',
      handle: '@verona_official',
      bio: 'Ancient city where we lay our scene. From ancient grudge break to new mutiny. 🏛️',
      avatar_url: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=150&h=150&fit=crop',
      followers: 5672,
      following: 12,
      posts_count: 45,
      verified: true
    }
  ]
};

export const mockPosts = [
  {
    id: 'post_1',
    instance_id: '1',
    entity_id: 'romeo_montague',
    type: 'post',
    title: 'But soft, what light through yonder window breaks?',
    body: 'It is the east, and Juliet is the sun! Arise, fair sun, and kill the envious moon, who is already sick and pale with grief that thou, her maid, art far more fair than she. 🌅✨',
    media_url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=400&fit=crop',
    likes: 1247,
    comments: 89,
    saves: 234,
    created_at: '2025-01-15T06:30:00Z',
    source_ref: 'Act II, Scene 2 - Balcony Scene',
    liked_by_user: true,
    saved_by_user: false
  },
  {
    id: 'post_2',
    instance_id: '1',
    entity_id: 'juliet_capulet',
    type: 'post',
    title: 'O Romeo, Romeo, wherefore art thou Romeo?',
    body: 'Deny thy father and refuse thy name! Or if thou wilt not, be but sworn my love, and I\'ll no longer be a Capulet. 💔 What\'s in a name anyway?',
    media_url: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&h=400&fit=crop',
    likes: 2156,
    comments: 167,
    saves: 445,
    created_at: '2025-01-15T06:35:00Z',
    source_ref: 'Act II, Scene 2 - Balcony Scene',
    liked_by_user: false,
    saved_by_user: true
  },
  {
    id: 'post_3',
    instance_id: '1',
    entity_id: 'mercutio',
    type: 'post',
    title: 'A plague on both your houses!',
    body: 'They have made worms\' meat of me! I have it, and soundly too. Your houses! 🗡️💀 Why the devil came you between us? I was hurt under your arm.',
    media_url: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop',
    likes: 892,
    comments: 234,
    saves: 156,
    created_at: '2025-01-14T18:45:00Z',
    source_ref: 'Act III, Scene 1 - Street Fight',
    liked_by_user: false,
    saved_by_user: false
  },
  {
    id: 'post_4',
    instance_id: '1',
    entity_id: 'verona_city',
    type: 'post',
    title: 'Another brawl in our fair streets',
    body: 'Civil blood makes civil hands unclean. When will these ancient grudges end? Our streets run red with the blood of youth. 🏛️⚔️',
    media_url: 'https://images.unsplash.com/photo-1539650116574-75c0c6d9f42b?w=400&h=400&fit=crop',
    likes: 445,
    comments: 67,
    saves: 89,
    created_at: '2025-01-14T16:20:00Z',
    source_ref: 'Act I, Scene 1 - Opening Brawl',
    liked_by_user: false,
    saved_by_user: false
  }
];

export const mockStories = [
  {
    id: 'story_1',
    instance_id: '1',
    entity_id: 'romeo_montague',
    type: 'story',
    cards: [
      {
        id: 'card_1',
        text: 'At the Capulet feast tonight',
        bg_media_url: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=400&h=600&fit=crop',
        created_at: '2025-01-15T20:30:00Z'
      },
      {
        id: 'card_2', 
        text: 'She doth teach the torches to burn bright!',
        bg_media_url: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=400&h=600&fit=crop',
        created_at: '2025-01-15T20:31:00Z'
      }
    ],
    viewed_by_user: false,
    created_at: '2025-01-15T20:30:00Z'
  },
  {
    id: 'story_2',
    instance_id: '1',
    entity_id: 'juliet_capulet',
    type: 'story',
    cards: [
      {
        id: 'card_3',
        text: 'My only love sprung from my only hate!',
        bg_media_url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=600&fit=crop',
        created_at: '2025-01-15T21:00:00Z'
      }
    ],
    viewed_by_user: true,
    created_at: '2025-01-15T21:00:00Z'
  }
];

export const mockReels = [
  {
    id: 'reel_1',
    instance_id: '1',
    entity_id: 'romeo_montague',
    type: 'reel',
    title: 'The Balcony Scene 🌙',
    video_url: 'https://player.vimeo.com/video/76979871',
    thumbnail_url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=600&fit=crop',
    captions: 'But soft, what light through yonder window breaks? It is the east, and Juliet is the sun!',
    likes: 3421,
    comments: 234,
    saves: 567,
    views: 12450,
    created_at: '2025-01-15T08:00:00Z',
    source_ref: 'Act II, Scene 2',
    liked_by_user: true
  },
  {
    id: 'reel_2',
    instance_id: '1',
    entity_id: 'mercutio',
    type: 'reel',
    title: 'Queen Mab Speech 🧚‍♀️',
    video_url: 'https://player.vimeo.com/video/76979871',
    thumbnail_url: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=600&fit=crop',
    captions: 'O, then I see Queen Mab hath been with you! She is the fairies\' midwife...',
    likes: 1892,
    comments: 156,
    saves: 289,
    views: 8934,
    created_at: '2025-01-14T19:30:00Z',
    source_ref: 'Act I, Scene 4',
    liked_by_user: false
  }
];

export const mockComments = [
  {
    id: 'comment_1',
    post_id: 'post_1',
    entity_id: 'juliet_capulet',
    text: 'My Romeo! 💕',
    likes: 45,
    created_at: '2025-01-15T06:45:00Z'
  },
  {
    id: 'comment_2',
    post_id: 'post_1', 
    entity_id: 'mercutio',
    text: 'Smooth words from our lovesick friend! 😏',
    likes: 23,
    created_at: '2025-01-15T07:20:00Z'
  },
  {
    id: 'comment_3',
    post_id: 'post_2',
    entity_id: 'romeo_montague',
    text: 'I take thee at thy word! Call me but love! 💍',
    likes: 89,
    created_at: '2025-01-15T06:40:00Z'
  }
];